<template>
    <div class="container">
        <div class="columns is-centered">
            <div class="column is-three-quarters">
                <div class="card">
                    <div class="card-content has-text-centered">
                        <figure class="image mx-auto">
                            <img src="https://cdn.alterdata.com.br/pack/packup/interno/assets/images/pack_web_2013.png" alt="logo" />
                        </figure>

                        <hr class="my-5" />

                        <h1 class="title is-3">
                            <span class="icon">
                                <i class="mdi mdi-cog"></i>
                            </span>
                            Estamos em manutenção!
                        </h1>

                        <p class="subtitle is-5">Estamos realizando uma manutenção de emergência. Desculpe-nos o transtorno!</p>
                        <!-- <p class="subtitle is-5 has-text-info no-margin">Previsão de retorno às 13:00 (horário de Brasília).</p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrfManutencao"
    }
</script>